export default __webpack_public_path__ + "static/media/licenseImg.c978bac4.png";